import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptor } from './httpInterceptor.service';
import { ConfigService } from '../services/config.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notify = new Subject<any>();
  notifyObservable$ = this.notify.asObservable();
  constructor(
    private _httpInterceptor: HttpInterceptor,
  ) { }
  public notifyOther(data: any) {
    if (data) {
      this.notify.next(data);
    }
  }
}
